import { render } from "./Acessos.vue?vue&type=template&id=9509c846"
import script from "./Acessos.vue?vue&type=script&lang=js"
export * from "./Acessos.vue?vue&type=script&lang=js"

import "./Acessos.vue?vue&type=style&index=0&id=9509c846&lang=css"

import exportComponent from "/opt/build/repo/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__